<style src="./BoardAssignedUser.scss" lang="scss"></style>
<template>
  <section class="board-assigned-user board-module">
    <span class="moduletitle">Participantes</span>
    <modal-users
      v-model="users"/>

    <button
      v-if="canShowParticipateTask"
      class="cp1-small-button cp1-button__warning"
      @click="taskParticipate">
      Participar da tarefa
    </button>
  </section>
</template>

<script>
import ModalUsers from '../../../modal-users/ModalUsers'

export default {
  name: 'BoardAssignedUser',
  components: {
    ModalUsers
  },
  props: {
    value: {
      default: null
    },
    canShowParticipateTask: {
      default: false
    }
  },
  data: () => ({
    users: null
  }),
  watch: {
    value: {
      handler (v) {
        this.users = v
      },
      immediate: true
    },
    users (v) {
      this.$emit('input', v)
    }
  },
  methods: {
    taskParticipate () { this.$emit('task-participate') }
  }
}
</script>



// WEBPACK FOOTER //
// src/view/board/components/board-details/components/board-assigned-user/BoardAssignedUser.vue